import {
    fontSizes, mediaQueries, radii, space, buttons
} from 'style/config';

export const skeletonStyles = {
    image: {
        paddingBottom: '100%',
        borderRadius: radii[2]
    },
    text: {
        borderRadius: radii.full
    },
    price: {
        display: 'block',
        width: '3em',
        borderRadius: radii.full,
        marginBottom: space[2]
    },
    button: {
        borderRadius: radii.full,
        height: buttons.HEIGHT_SM,
        width: '100%',
        marginTop: 'auto'
    }
};

export const styles = {
    cellTop: {
        display: 'flex',
        flexDirection: 'column',
        height: 268,
        [mediaQueries.sm]: {
            height: 274
        }
    },
    cell: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        paddingTop: space[3],
        paddingBottom: space[3]
    },
    ql: {
        '& .ProductTableItem-ql': {
            opacity: 0,
            transition: 'opacity .2s',
            [mediaQueries.xsMax]: {
                display: 'none'
            }
        },
        '.no-touch &:hover, :focus, :focus-within': {
            '& .ProductTableItem-ql': {
                opacity: 1
            }
        }
    },
    priceList: {
        fontWeight: 'var(--font-weight-normal)',
        textDecoration: 'line-through'
    },
    reviewCount: {
        fontSize: fontSizes.sm,
        marginLeft: '.375em',
        position: 'relative',
        top: '.0625em'
    },
    reviewRating: {
        fontSize: fontSizes.sm,
        fontWeight: 'bold',
        marginRight: '.375em',
        position: 'relative',
        top: '.0625em'
    },
    highlyRatedLabel: {
        fontWeight: 'bold'
    }
};
